<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>

<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    props: {
      echartsData: {
        type: Object
      },
    },
    setup(props) {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            tooltip: {trigger: 'axis'},
            legend: {               //设置区分（哪条线属于什么）
              data: props.echartsData.dataName
            },
            xAxis: {
              type: "category",
              data:props.echartsData.date,
              boundaryGap: false,     //坐标轴两边不留白
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: props.echartsData.dataName[0],
                data: props.echartsData.data1,
                type: 'line',
                symbolSize: 6, 
                smooth: true
              },
              {
                name: props.echartsData.dataName[1],
                data: props.echartsData.data2,
                type: 'line',
                symbolSize: 6, 
                smooth: true
              },
              {
                name: props.echartsData.dataName[2],
                data: props.echartsData.data3,
                type: 'line',
                symbolSize: 6, 
                smooth: true
              }
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>